import axios from "axios";

export const client = axios.create({
  baseURL: "http://localhost:3030",
  headers: {
    "Content-Type": "application/json"
  }
})


// WEBPACK FOOTER //
// ./src/actions/index.js